export default class PermissionResolver {

    static GLOBAL_PERMISSION_SCOPE = "*";


    constructor(private readonly grantedPermissions: Permission[]) {
    }

    hasPermission(permissionDesc: string, contractId?: string, contractGroupId?: string): boolean {
        const permissionItems = permissionDesc.split(':');
        const required: Permission = {
            resources: [permissionItems[0].toUpperCase()],
            actions: [permissionItems[1].toUpperCase()],
            contractId: contractId ?? PermissionResolver.GLOBAL_PERMISSION_SCOPE,
            contractGroupId: contractGroupId ?? PermissionResolver.GLOBAL_PERMISSION_SCOPE,
        };
        const result = this.grantedPermissions.some(granted => permits(granted, required));
        return result;
    }

    hasPermissionInAnyScope(resource: string, action: string) {
        const result = this.grantedPermissions.some(granted => {
            return matches(granted.resources, [resource]) && matches(granted.actions, [action]);
        })
        return result;
    }
}

function permits(granted: Permission, required: Permission) {
    let GLOBAL = PermissionResolver.GLOBAL_PERMISSION_SCOPE;
    let matched = matches(granted.resources, required.resources) && matches(granted.actions, required.actions);

    if (!matched) {
        return false;
    }

    // requires GLOBAL contractId
    if (required.contractId === GLOBAL && granted.contractId !== undefined) {
        return false;
    }

    // Requires GLOBAL groupId
    if (required.contractGroupId === GLOBAL && granted.contractGroupId !== undefined) {
        return false;
    }

    // requires matching contractId
    if (required.contractId !== GLOBAL) {
        if (granted.contractId !== undefined && granted.contractId !== required.contractId) {
            return false;
        }
    }

    // requires matching groupId
    if (required.contractGroupId !== GLOBAL) {
        if (granted.contractGroupId !== undefined && granted.contractGroupId !== required.contractGroupId) {
            return false;
        }
    }

    return true;
}


function matches(granted: string[], required: string[]) {
    return granted.includes('*') || required.every(req => granted.includes(req));
}

export interface Permission {
    resources: string[],
    actions: string[],
    contractId?: string,
    contractGroupId?: string,
}
